export const getHost = () => (window._env_ && window._env_.REACT_APP_HOST) || process.env.REACT_APP_HOST;

export const isUnderConstruction = () => {
  const raw =
    (window._env_ && window._env_.REACT_APP_UNDER_CONSTRUCTION) ||
    process.env.REACT_APP_UNDER_CONSTRUCTION;
  return String(raw).toLowerCase() === 'true';
};
